export enum CalendarIDs {
    OvertimeCalendarForHusbandry = 7,
    OvertimeCalendarForSupervisor = 8,
    PTOCalendarForSupervisor = 9,
    PTOCalendarForHusbandry = 10
}
